<script setup>
import { computed, ref, watch } from 'vue'
import supplierHttp from '@supplier/http/supplierHttp'
import { useSupplierSessionStore } from '@supplier/stores/useSupplierSessionStore'
import { useI18n } from 'vue-i18n'

import { useSupplierNotify } from '@supplier/composables/useSupplierNotify'

import { SUPPLIER_API } from '@supplier/http/api-routes'

import AppButton from '@ui/app-button/AppButton.vue'
import AppModal from '@ui/app-modal/AppModal.vue'

const { t } = useI18n()
const notify = useSupplierNotify()
const session = useSupplierSessionStore()

const needsReauth = ref(false)
const dismissed = ref(false)
const isAuthorizing = ref(false)
let checked = false

const isOpen = computed(() => needsReauth.value && !dismissed.value)

watch(() => session.store, async(store) => {
  if (!store || checked) return
  checked = true
  try {
    const { data } = await supplierHttp.get(SUPPLIER_API.shopifyReauthStatus)
    needsReauth.value = data?.needs_reauth === true
  } catch {
    needsReauth.value = false
  }
}, { immediate: true })

async function authorize() {
  if (isAuthorizing.value) return
  isAuthorizing.value = true
  try {
    const { data } = await supplierHttp.get(SUPPLIER_API.shopifyReauthUrl)
    if (data?.url) {
      window.location.assign(data.url)
      return
    }
    dismissed.value = true
  } catch (error) {
    notify.error(error)
    dismissed.value = true
  }
  isAuthorizing.value = false
}
</script>

<template>
  <app-modal
    :model-value="isOpen"
    :close="false"
    :title="t('ui.supplier_portal.reauth.title')"
    :text="t('ui.supplier_portal.reauth.text')"
    data-element="supplier-reauth-modal"
  >
    <template #footer>
      <app-button
        variant="accent"
        block
        :loading="isAuthorizing"
        data-element="supplier-reauth-authorize-btn"
        @click="authorize"
      >
        {{ t('ui.supplier_portal.reauth.authorize') }}
      </app-button>
    </template>
  </app-modal>
</template>
